import { FetcherEmptyResponse } from '@/types/types';
import { isFetcherLoading } from '@/utils/helpers';
import { useEffect, useRef } from 'react';
import { useFetcher } from 'react-router-dom';

export function useFetcherWithUtils<FetcherData extends FetcherEmptyResponse>(
  onSuccess?: ((fetcherData: FetcherData) => void) | (() => void),
) {
  const fetcher = useFetcher<FetcherData>();
  const isLoading = isFetcherLoading(fetcher.state);
  const isSuccess =
    !isLoading && !fetcher.data?.error && typeof fetcher.data !== 'undefined';

  const wasSuccessRef = useRef(false);

  useEffect(() => {
    if (isSuccess && !wasSuccessRef.current && typeof fetcher.data !== 'undefined') {
      wasSuccessRef.current = true;
      onSuccess?.(fetcher.data);
    } else if (!isSuccess) {
      wasSuccessRef.current = false;
    }
  }, [fetcher.data, isSuccess, onSuccess]);

  return [fetcher, isLoading, isSuccess] as const;
}
